<div class="p-col-12 p-lg-12">
  <div class="ui-g card">
    <div class="ui-g-12 ui-md-12 ui-lg-12">
      @for (message of msgs; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
      @if (showForm) {
        <form [formGroup]="paymentBatchForm" (ngSubmit)="onSubmit()">
          <div class="ui-g">
            <div class="ui-g-12 ui-md-8 ui-lg-6">
              <div class="reqfields">
                <span class="indicate">*</span> required fields
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Batch Create Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="paymentBatchScheduleDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Anticipated Payment Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="anticipatedPaymentDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">Actual Payment Central Date</div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="actualPaymentCentralDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Payment Batch Status<span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-select
                    [options]="paymentBatchStatus"
                    placeholder="Select"
                    formControlName="paymentBatchStatus"
                    optionLabel="eventPaymentBatchStatus"></p-select>
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g bdr">
            @if (loading) {
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
              </div>
            }
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <p-table
                #dt
                [columns]="engcols"
                editMode="row"
                [(selection)]="selectedEvents"
                dataKey="eventKey"
                [value]="eventList"
                selectionMode="multiple"
                [showLoader]="true"
                [scrollable]="true"
                [style]="{ width: '100%' }"
                scrollWidth="500px"
                scrollHeight="500px"
                frozenWidth="400px"
                [loadingIcon]="loadingIcon"
                [paginator]="true"
                [rows]="dataViewRecsPerPage"
                (onPage)="pageChange($event)"
                [pageLinks]="pageLinksPerPage"
                paginatorPosition="top"
                (onFilter)="applyFilter($event)">
                <ng-template pTemplate="caption">
                  <div style="text-align: left">
                    <input
                      type="text"
                      pInputText
                      size="30"
                      placeholder="Search"
                      (input)="
                        dt.filterGlobal($any($event.target).value, 'contains')
                      "
                      style="width: auto"
                      [value]="
                        dt.filters['global']
                          ? $any(dt.filters['global']).value
                          : ''
                      " />
                    <i class="fa fa-search ml-2"></i>
                    <span class="pageInfo visiblelg resettble">{{
                      currentPageInfo
                    }}</span>
                    <span style="float: right"
                      ><a
                        (click)="reset()"
                        (keydown.enter)="reset()"
                        tabindex="0"
                        ><span class="fa fa-repeat"></span> Reset table</a
                      ></span
                    >
                  </div>
                </ng-template>
                <ng-template #header let-columns>
                  <tr>
                    <th class="dashtable colchck" pFrozenColumn>
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th class="coleditrow" pFrozenColumn></th>
                    @if (isMRPP) {
                      <th
                        [pSortableColumn]="'eventKey'"
                        class="coleventkey coleventpadding"
                        style="align-content: center"
                        pFrozenColumn>
                        Line Item ID<p-sortIcon
                          [field]="'eventKey'"></p-sortIcon
                        ><br /><br />
                      </th>
                    }
                    @if (!isMRPP) {
                      <th
                        [pSortableColumn]="'eventKey'"
                        class="coleventkey coleventpadding"
                        style="align-content: center"
                        pFrozenColumn>
                        Event Key<p-sortIcon [field]="'eventKey'"></p-sortIcon
                        ><br /><br />
                      </th>
                    }
                    <th
                      [pSortableColumn]="'eventRegistrationId'"
                      class="colsmall">
                      {{ engagementId
                      }}<p-sortIcon [field]="'partnerName'"></p-sortIcon>
                    </th>
                    @if (!isHidden('programType')) {
                      <th [pSortableColumn]="'programType'" class="colmedium">
                        Program Type<p-sortIcon
                          [field]="'programType'"></p-sortIcon>
                      </th>
                    }
                    <th [pSortableColumn]="'eventName'" class="colmedium">
                      {{ engagementName
                      }}<p-sortIcon [field]="'eventName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerName'" class="colsmall">
                      Partner Name<p-sortIcon
                        [field]="'partnerName'"></p-sortIcon>
                    </th>
                    @if (!isHidden('payeeID')) {
                      <th [pSortableColumn]="'payeeID'" class="colsmall">
                        Payee ID<p-sortIcon [field]="'payeeID'"></p-sortIcon>
                      </th>
                    }
                    @if (!isHidden('customerTenantId')) {
                      <th
                        [pSortableColumn]="'customerTenantId'"
                        class="colsmall">
                        Customer TenantID<p-sortIcon
                          [field]="'customerTenantId'"></p-sortIcon>
                      </th>
                    }
                    @if (!isHidden('payoutMetric')) {
                      <th [pSortableColumn]="'payoutMetric'" class="colsmall">
                        {{ payoutMetric
                        }}<p-sortIcon [field]="'payoutMetric'"></p-sortIcon>
                      </th>
                    }
                    @if (!isHidden('tier')) {
                      <th [pSortableColumn]="'tier'" class="colsmall">
                        Milestone 2 Tier<p-sortIcon
                          [field]="'tier'"></p-sortIcon>
                      </th>
                    }
                    @if (!isHidden('maturityStatus')) {
                      <th [pSortableColumn]="'maturityStatus'" class="colsmall">
                        Maturity Status<p-sortIcon
                          [field]="'maturityStatus'"></p-sortIcon>
                      </th>
                    }
                    @if (!isHidden('maturityDate')) {
                      <th [pSortableColumn]="'maturityDate'" class="colmedium">
                        Maturity Date<p-sortIcon
                          [field]="'maturityDate'"></p-sortIcon>
                      </th>
                    }
                    @if (!isHidden('fundingAmount')) {
                      <th [pSortableColumn]="'fundingAmount'" class="colsmall">
                        Funding Amount<p-sortIcon
                          [field]="'fundingAmount'"></p-sortIcon>
                      </th>
                    }
                    <th [pSortableColumn]="'partnerLocation'" class="colsmall">
                      Partner Location<p-sortIcon
                        [field]="'partnerLocation'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'fiscalYear'" class="colsmall">
                      Fiscal Year<p-sortIcon
                        [field]="'fiscalYear'"></p-sortIcon>
                    </th>
                    @if (!isHidden('m2CategoryTypeValue')) {
                      <th
                        [pSortableColumn]="'m2CategoryTypeValue'"
                        class="colsmall">
                        M2CategoryTypeValue<p-sortIcon
                          [field]="'m2CategoryTypeValue'"></p-sortIcon>
                      </th>
                    }
                    <th [pSortableColumn]="'profileStatus'" class="colsmall">
                      ProfileStatus<p-sortIcon
                        [field]="'profileStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerPriority'" class="colsmall">
                      Partner Priority<p-sortIcon
                        [field]="'partnerPriority'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'blockedStatus'" class="colsmall">
                      Blocked Status<p-sortIcon
                        [field]="'blockedStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerId'" class="colsmall">
                      Partner ID<p-sortIcon [field]="'partnerId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'payeeName'" class="colsmall">
                      Payee Name<p-sortIcon [field]="'payeeName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactName'" class="colsmall">
                      Contact Name<p-sortIcon
                        [field]="'contactName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactEmail'" class="colsmall">
                      Contact Email<p-sortIcon
                        [field]="'contactEmail'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'emailLanguage'" class="colsmall">
                      Email Language<p-sortIcon
                        [field]="'emailLanguage'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'accountCode'" class="colsmall">
                      Account Code<p-sortIcon
                        [field]="'accountCode'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'internalOrderOrCostCenter'"
                      class="colsmall">
                      Internal Order or<br />Cost Center<p-sortIcon
                        [field]="'internalOrderOrCostCenter'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'currency'" class="colxsmall">
                      Currency<p-sortIcon [field]="'currency'"></p-sortIcon>
                    </th>
                    @if (!isHidden('amount')) {
                      <th [pSortableColumn]="'amount'" class="colxsmall">
                        Amount<p-sortIcon [field]="'amount'"></p-sortIcon>
                      </th>
                    }
                    <th [pSortableColumn]="'netAmount'" class="colxsmall">
                      Net Amount<p-sortIcon [field]="'netAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'taxAmount'" class="colxsmall">
                      Tax Amount<p-sortIcon [field]="'taxAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'msInvoiceNumber'" class="colmedium">
                      MS Invoice Number<p-sortIcon
                        [field]="'msInvoiceNumber'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'msInvoicePaidDate'"
                      class="colmedium">
                      MS Invoice Paid Date<p-sortIcon
                        [field]="'msInvoicePaidDate'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'paymentCentralTransactionId'"
                      class="collarge">
                      Payment Central<br />Transaction ID<p-sortIcon
                        [field]="'paymentCentralTransactionId'"></p-sortIcon>
                    </th>
                    @if (!isHidden('paymentDocumentNumber')) {
                      <th
                        [pSortableColumn]="'paymentDocumentNumber'"
                        class="colmedium">
                        Payment<br />Document Number<p-sortIcon
                          [field]="'paymentDocumentNumber'"></p-sortIcon>
                      </th>
                    }
                  </tr>
                  <tr>
                    <th class="colchck" pFrozenColumn></th>
                    <th class="coleditrow" pFrozenColumn></th>
                    <th class="dashtable coleventkey" pFrozenColumn>
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'eventKey',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['eventKey']
                            ? $any(dt.filters['eventKey']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'eventRegistrationId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['eventRegistrationId']
                            ? $any(dt.filters['eventRegistrationId']).value
                            : ''
                        " />
                    </th>
                    @if (!isHidden('programType')) {
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'programType',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['programType']
                              ? $any(dt.filters['programType']).value
                              : ''
                          " />
                      </th>
                    }
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'eventName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['eventName']
                            ? $any(dt.filters['eventName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerName']
                            ? $any(dt.filters['partnerName']).value
                            : ''
                        " />
                    </th>
                    @if (!isHidden('payeeID')) {
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'payeeID',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['payeeID']
                              ? $any(dt.filters['payeeID']).value
                              : ''
                          " />
                      </th>
                    }
                    @if (!isHidden('customerTenantId')) {
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'customerTenantId',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['customerTenantId']
                              ? $any(dt.filters['customerTenantId']).value
                              : ''
                          " />
                      </th>
                    }
                    @if (!isHidden('payoutMetric')) {
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'payoutMetric',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['payoutMetric']
                              ? $any(dt.filters['payoutMetric']).value
                              : ''
                          " />
                      </th>
                    }
                    @if (!isHidden('tier')) {
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'tier',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['tier']
                              ? $any(dt.filters['tier']).value
                              : ''
                          " />
                      </th>
                    }
                    @if (!isHidden('maturityStatus')) {
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'maturityStatus',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['maturityStatus']
                              ? $any(dt.filters['maturityStatus']).value
                              : ''
                          " />
                      </th>
                    }
                    @if (!isHidden('maturityDate')) {
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'maturityDate',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['maturityDate']
                              ? $any(dt.filters['maturityDate']).value
                              : ''
                          " />
                      </th>
                    }
                    @if (!isHidden('fundingAmount')) {
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'fundingAmount',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['fundingAmount']
                              ? $any(dt.filters['fundingAmount']).value
                              : ''
                          " />
                      </th>
                    }
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerLocation',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerLocation']
                            ? $any(dt.filters['partnerLocation']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'fiscalYear',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['fiscalYear']
                            ? $any(dt.filters['fiscalYear']).value
                            : ''
                        " />
                    </th>
                    @if (!isHidden('m2CategoryTypeValue')) {
                      <th class="dashtable colsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'm2CategoryTypeValue',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['m2CategoryTypeValue']
                              ? $any(dt.filters['m2CategoryTypeValue']).value
                              : ''
                          " />
                      </th>
                    }
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'profileStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['profileStatus']
                            ? $any(dt.filters['profileStatus']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerPriority',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerPriority']
                            ? $any(dt.filters['partnerPriority']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'blockedStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['blockedStatus']
                            ? $any(dt.filters['blockedStatus']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerId']
                            ? $any(dt.filters['partnerId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'payeeName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['payeeName']
                            ? $any(dt.filters['payeeName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'contactName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['contactName']
                            ? $any(dt.filters['contactName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'contactEmail',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['contactEmail']
                            ? $any(dt.filters['contactEmail']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'emailLanguage',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['emailLanguage']
                            ? $any(dt.filters['emailLanguage']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'accountCode',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['accountCode']
                            ? $any(dt.filters['accountCode']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'internalOrderOrCostCenter',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['internalOrderOrCostCenter']
                            ? $any(dt.filters['internalOrderOrCostCenter'])
                                .value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'currency',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['currency']
                            ? $any(dt.filters['currency']).value
                            : ''
                        " />
                    </th>
                    @if (!isHidden('amount')) {
                      <th class="dashtable colxsmall">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'amount',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['amount']
                              ? $any(dt.filters['amount']).value
                              : ''
                          " />
                      </th>
                    }
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'netAmount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['netAmount']
                            ? $any(dt.filters['netAmount']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'taxAmount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['taxAmount']
                            ? $any(dt.filters['taxAmount']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'msInvoiceNumber',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['msInvoiceNumber']
                            ? $any(dt.filters['msInvoiceNumber']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'msInvoicePaidDate',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['msInvoicePaidDate']
                            ? $any(dt.filters['msInvoicePaidDate']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable collarge">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'paymentCentralTransactionId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['paymentCentralTransactionId']
                            ? $any(dt.filters['paymentCentralTransactionId'])
                                .value
                            : ''
                        " />
                    </th>
                    @if (!isHidden('paymentDocumentNumber')) {
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'paymentDocumentNumber',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['paymentDocumentNumber']
                              ? $any(dt.filters['paymentDocumentNumber']).value
                              : ''
                          " />
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template
                  #body
                  let-rowData
                  let-columns="columns"
                  let-ri="rowIndex">
                  <tr [pEditableRow]="rowData" class="wa-uneven-height-fix">
                    <td class="colchck wa-uneven-height-fix" pFrozenColumn>
                      <p-checkbox
                        name="chcklist"
                        inputId="eng_chk_{{ rowData.eventKey }}"
                        [value]="rowData"
                        formControlName="selectedEvents"
                        [(ngModel)]="selectedEvents"></p-checkbox>
                    </td>
                    <td
                      class="dashtable coleditrow"
                      style="text-align: center"
                      pFrozenColumn></td>
                    <td class="coleventkey" pFrozenColumn>
                      {{ rowData.eventKey }}
                    </td>
                    @if (!isHidden('eventKey')) {
                      <td class="colsmall" pFrozenColumn>
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.eventRegistrationId }}"
                          >{{ rowData.eventRegistrationId }}</span
                        >
                      </td>
                    }
                    @if (!isHidden('programType')) {
                      <td class="colmedium">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.programType }}"
                          >{{ rowData.programType }}</span
                        >
                      </td>
                    }
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.eventName }}"
                        >{{ rowData.eventName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerName }}"
                        >{{ rowData.partnerName }}</span
                      >
                    </td>
                    @if (!isHidden('payeeID')) {
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.payeeID }}"
                          >{{ rowData.payeeID }}</span
                        >
                      </td>
                    }
                    @if (!isHidden('customerTenantId')) {
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.customerTenantId }}"
                          >{{ rowData.customerTenantId }}</span
                        >
                      </td>
                    }
                    @if (!isHidden('payoutMetric')) {
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.payoutMetric }}"
                          >{{ rowData.payoutMetric }}</span
                        >
                      </td>
                    }
                    @if (!isHidden('tier')) {
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.tier }}"
                          >{{ rowData.tier }}</span
                        >
                      </td>
                    }
                    @if (!isHidden('maturityStatus')) {
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.maturityStatus }}"
                          >{{ rowData.maturityStatus }}</span
                        >
                      </td>
                    }
                    @if (!isHidden('maturityDate')) {
                      <td class="colmedium">
                        @if (rowData.maturityDate !== null) {
                          <span
                            tooltipPosition="top"
                            pTooltip="{{
                              rowData.maturityDate | date: 'MM/dd/yyyy'
                            }}"
                            >{{
                              rowData.maturityDate | date: 'MM/dd/yyyy'
                            }}</span
                          >
                        }
                        @if (rowData.maturityDate === null) {
                          <span>Missing</span>
                        }
                      </td>
                    }
                    @if (!isHidden('fundingAmount')) {
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.fundingAmount }}"
                          >{{ rowData.fundingAmount }}</span
                        >
                      </td>
                    }
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerLocation }}"
                        >{{ rowData.partnerLocation }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.fiscalYear }}"
                        >{{ rowData.fiscalYear }}</span
                      >
                    </td>
                    @if (!isHidden('m2CategoryTypeValue')) {
                      <td class="colsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.m2CategoryTypeValue }}"
                          >{{ rowData.m2CategoryTypeValue }}</span
                        >
                      </td>
                    }
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.profileStatus }}"
                        >{{ rowData.profileStatus }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerPriority }}"
                        >{{ rowData.partnerPriority }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.blockedStatus }}"
                        >{{ rowData.blockedStatus }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerId }}"
                        >{{ rowData.partnerId }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.payeeName }}"
                        >{{ rowData.payeeName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.contactName }}"
                        >{{ rowData.contactName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.contactEmail }}"
                        >{{ rowData.contactEmail }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.emailLanguage }}"
                        >{{ rowData.emailLanguage }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.accountCode }}"
                        >{{ rowData.accountCode }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.internalOrderOrCostCenter }}"
                        >{{ rowData.internalOrderOrCostCenter }}</span
                      >
                    </td>
                    <td class="colxsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.currency }}"
                        >{{ rowData.currency }}</span
                      >
                    </td>
                    @if (!isHidden('amount')) {
                      <td class="colxsmall">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.amount }}"
                          >{{ rowData.amount }}</span
                        >
                      </td>
                    }
                    <td class="colxsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.netAmount }}"
                        >{{ rowData.netAmount }}</span
                      >
                    </td>
                    <td class="colxsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.taxAmount }}"
                        >{{ rowData.taxAmount }}</span
                      >
                    </td>
                    <td class="colmedium">
                      @if (
                        rowData.msInvoiceNumber !== null &&
                        rowData.msInvoiceNumber !== ''
                      ) {
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.msInvoiceNumber }}"
                          >{{ rowData.msInvoiceNumber }}</span
                        >
                      }
                      @if (
                        rowData.msInvoiceNumber === null ||
                        rowData.msInvoiceNumber === ''
                      ) {
                        <span>Missing</span>
                      }
                    </td>
                    <td class="colmedium">
                      @if (rowData.msInvoicePaidDate !== null) {
                        <span
                          tooltipPosition="top"
                          pTooltip="{{
                            rowData.msInvoicePaidDate | date: 'MM/dd/yyyy'
                          }}"
                          >{{
                            rowData.msInvoicePaidDate | date: 'MM/dd/yyyy'
                          }}</span
                        >
                      }
                      @if (rowData.msInvoicePaidDate === null) {
                        <span>Missing</span>
                      }
                    </td>
                    <td class="collarge">
                      @if (
                        rowData.paymentCentralTransactionId !== null &&
                        rowData.paymentCentralTransactionId !== ''
                      ) {
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.paymentCentralTransactionId }}"
                          >{{ rowData.paymentCentralTransactionId }}</span
                        >
                      }
                      @if (
                        rowData.paymentCentralTransactionId === null ||
                        rowData.paymentCentralTransactionId === ''
                      ) {
                        <span tooltipPosition="top">Missing</span>
                      }
                    </td>
                    @if (!isHidden('paymentDocumentNumber')) {
                      <td class="colmedium">
                        @if (
                          rowData.paymentDocumentNumber !== null &&
                          rowData.paymentDocumentNumber !== ''
                        ) {
                          <span
                            tooltipPosition="top"
                            pTooltip="{{ rowData.paymentDocumentNumber }}"
                            >{{ rowData.paymentDocumentNumber }}</span
                          >
                        }
                        @if (
                          rowData.paymentDocumentNumber === null ||
                          rowData.paymentDocumentNumber === ''
                        ) {
                          <span>Missing</span>
                        }
                      </td>
                    }
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          @for (message of msgs; track message) {
            <p-message [life]="3000" [text]="message.detail"></p-message>
          }
          <div class="ui-g">
            <div class="ui-g-12 ui-md-12 ui-lg-12 mar10">
              <button
                type="submit"
                pButton
                [disabled]="!paymentBatchForm.valid"
                class="flat btnmr">
                Submit
              </button>
              <button
                type="button"
                pButton
                (click)="cancelSearchNav()"
                class="ui-button-secondary flat">
                Cancel
              </button>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
